<div class="card-header-wrapper">
  <div class="title-wrapper">
    <msd-avatar [text]="initials" [src]="pictureUrl"></msd-avatar>
    <span class="title">Encouragement</span>
  </div>
  <span *ngIf="reaction && reaction.length > 0" class="reaction">{{reaction}}</span>
</div>

<span class="encouragement-message">{{ message && message.length > 0 ? '“' + message + '”'  : 'Aucun message' }}</span>
